import { render, staticRenderFns } from "./ChannelPartnerReviewHeading.vue?vue&type=template&id=d6b1b54a&"
import script from "./ChannelPartnerReviewHeading.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerReviewHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports